// Shared program catalog — used by Home, Programs list, and Program detail pages.
// Official HOFA program list (corrected per founder, Oct 2026).
// Images are Unsplash placeholders — replace with real HOFA photos when provided.

const P = {
  colors: {
    education: "#D98A18",
    research: "#31517E",
    social: "#C05A3A",
    economic: "#1F5C38",
    health: "#A62639",
  },
  labels: {
    education: "Education",
    research: "Research",
    social: "Social Engagement",
    economic: "Economic Empowerment",
    health: "Health Services",
  },
};

export const PROGRAM_COLORS = P.colors;
export const PROGRAM_LABELS = P.labels;

const IMG = {
  books: "https://images.unsplash.com/photo-1497486751825-1233686d5d80?auto=format&fit=crop&w=1600&q=80",
  workshop: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=1600&q=80",
  classroom: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=1600&q=80",
  laptop: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1600&q=80",
  data: "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?auto=format&fit=crop&w=1600&q=80",
  film: "https://images.unsplash.com/photo-1585699324551-f6c309eedeca?auto=format&fit=crop&w=1600&q=80",
  mic: "https://images.unsplash.com/photo-1590602847861-f357a9332bbc?auto=format&fit=crop&w=1600&q=80",
  football: "https://images.unsplash.com/photo-1517927033932-b3d18e61fb3a?auto=format&fit=crop&w=1600&q=80",
  vocational: "https://images.unsplash.com/photo-1581092160607-ee22621dd758?auto=format&fit=crop&w=1600&q=80",
  community: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=1600&q=80",
  health: "https://images.unsplash.com/photo-1584515933487-779824d29309?auto=format&fit=crop&w=1600&q=80",
};

export const PROGRAMS = [
  {
    slug: "mdgclp",
    key: "education",
    title: "MDGCLP",
    full: "Mah Doe Gibson Computer Literacy Program",
    tagline: "Hands-on computer skills for students and adults in District 17.",
    image: IMG.laptop,
    body:
      "Named in honor of Mah Doe Gibson, MDGCLP teaches practical digital literacy — from typing and documents to email, spreadsheets, and safe internet use — in community computer labs and partner schools.",
    highlights: ["Beginner to intermediate tracks", "School and community-lab sessions", "Certificate on completion"],
    impact: "Digital literacy cohorts run each school term.",
    testimonials: [],
  },
  {
    slug: "sgtats",
    key: "education",
    title: "SGTATS",
    full: "Susannah Gibson Training for Administrators, Teachers and Students",
    tagline: "Professional training that lifts whole school communities.",
    image: IMG.workshop,
    body:
      "Named in honor of Susannah Gibson, SGTATS runs practical workshops for school administrators, teachers, and students — covering classroom management, leadership, study skills, and school governance.",
    highlights: ["Administrator, teacher & student tracks", "In-school workshops", "Follow-up coaching visits"],
    impact: "Partner schools across Brewerville and District 17.",
    testimonials: [],
  },
  {
    slug: "kwwec",
    key: "education",
    title: "KWWEC",
    full: "Kay William Wanbo Essay Competition",
    tagline: "Young writers compete, and find their voice.",
    image: IMG.books,
    body:
      "Named in honor of Kay William Wanbo, this annual essay competition invites students across the district to write on themes of community, character, and country — with recognition and awards for the strongest voices.",
    highlights: ["Annual district-wide competition", "Themed essay prompts", "Awards and public recognition"],
    impact: "Open to schools across District 17 each academic year.",
    testimonials: [],
  },
  {
    slug: "btea",
    key: "education",
    title: "BTEA",
    full: "Bleedee Tue Academic Excellence Award",
    tagline: "Honoring the district's most outstanding students.",
    image: IMG.classroom,
    body:
      "Named in honor of Bleedee Tue, BTEA recognizes academic excellence — celebrating top-performing students and the teachers and families behind them at a public award ceremony.",
    highlights: ["Academic excellence awards", "Public ceremony", "Teacher and family recognition"],
    impact: "Awarded annually.",
    testimonials: [],
  },
  {
    slug: "eatqc",
    key: "education",
    title: "EATQC",
    full: "Ellis Archie Tue Quizzing & Spelling Bee Competition",
    tagline: "Quick minds and careful spellers, on stage.",
    image: IMG.workshop,
    body:
      "Named in honor of Ellis Archie Tue, EATQC brings schools together for quizzing and spelling bee contests — building confidence, mastery, and healthy rivalry among students.",
    highlights: ["Inter-school quiz contests", "Spelling bee rounds", "Trophies and school prizes"],
    impact: "Schools across Brewerville compete each year.",
    testimonials: [],
  },
  {
    slug: "mawascf",
    key: "education",
    title: "MAWASCF",
    full: "Mary Wanbo Scholarship and Community Fund",
    tagline: "Scholarships that keep promising students in school.",
    image: IMG.books,
    body:
      "Named in honor of Mary Wanbo, MAWASCF provides scholarships and community support funds for students whose families could not otherwise afford fees, uniforms, and materials.",
    highlights: ["School-fee scholarships", "Uniforms & materials support", "Community hardship fund"],
    impact: "Scholarships awarded each academic year.",
    testimonials: [],
  },
  {
    slug: "cicms",
    key: "education",
    title: "CICMS",
    full: "Christ Intervention Chukwu Memorial School",
    tagline: "A school of our own, raising the next generation.",
    image: IMG.classroom,
    isNew: true,
    body:
      "HOFA's newest education venture, the Christ Intervention Chukwu Memorial School provides quality foundational education in a caring, disciplined environment — built to serve families in and around Brewerville.",
    highlights: ["Foundational education", "Values-centered environment", "Serving Brewerville families"],
    impact: "New — launching now.",
    testimonials: [],
  },
  {
    slug: "cmfrii",
    key: "research",
    title: "CMFRII",
    full: "C. Mercy Frank Research and Innovation Initiative",
    tagline: "Community-driven studies that shape every HOFA decision.",
    image: IMG.data,
    body:
      "Named in honor of C. Mercy Frank, CMFRII partners with universities and community members to run household surveys, program evaluations, and rapid needs assessments. Every HOFA program cycle begins with CMFRII data.",
    highlights: ["Household surveys designed with communities", "Independent program evaluation", "Open publication of findings"],
    impact: "3 peer-reviewed community reports published since 2023.",
    testimonials: [
      { name: "Dr. Solomon B.", role: "CMFRII research partner, Univ. of Liberia", quote: "This is what community-owned research actually looks like." },
    ],
  },
  {
    slug: "hofaviproc",
    key: "social",
    title: "HOFAVIPROC",
    full: "Video Production and Media Development Program",
    tagline: "Documentary storytelling and media skills from rural Liberia.",
    image: IMG.film,
    body:
      "HOFAVIPROC is HOFA's in-house film and media unit. Its flagship series 'Life in Rural Liberia' captures the everyday resilience and craftsmanship of communities across the country, while training young videographers.",
    highlights: ["'Life in Rural Liberia' documentary series", "Youth videographer apprenticeships", "Screened at community film nights"],
    impact: "12 short films produced; 5,000+ views across Liberian community channels.",
    testimonials: [
      { name: "Mercy K.", role: "Documentary subject, Ep. 2", quote: "Nobody had ever asked me to tell my own story on camera. Now my grandchildren will see it." },
    ],
  },
  {
    slug: "mdw-cei",
    key: "social",
    title: "MDW-CEI",
    full: "Michael D. Wanbo Community Engagement Initiative",
    tagline: "Civic life, town halls, and community action.",
    image: IMG.community,
    body:
      "Named in honor of Michael D. Wanbo, MDW-CEI organizes town halls, community dialogues, and volunteer action days — giving residents a structured voice in the decisions that shape their towns.",
    highlights: ["Community town halls", "Volunteer action days", "Civic education"],
    impact: "Dialogues held across District 17 communities.",
    testimonials: [],
  },
  {
    slug: "hofa-music",
    key: "social",
    title: "HOFA MUSIC",
    full: "Music & Creative Arts Program",
    tagline: "Songs, instruments, and stages for young talent.",
    image: IMG.mic,
    isNew: true,
    body:
      "HOFA MUSIC is our newest creative arts program — nurturing young musicians and performers with instruments, practice space, mentorship, and community performances.",
    highlights: ["Instruments & practice space", "Mentorship from working musicians", "Community performances"],
    impact: "New — launching now.",
    testimonials: [],
  },
  {
    slug: "hofa-social-media",
    key: "social",
    title: "HOFA Social Media Platforms",
    full: "Community Channels & Storytelling",
    tagline: "Bringing District 17's stories to the world.",
    image: IMG.laptop,
    body:
      "HOFA's social media platforms share field updates, documentaries, and community celebrations — connecting supporters in Liberia and abroad with the work in real time.",
    highlights: ["Field updates & stories", "Documentary distribution", "Supporter community"],
    impact: "Thousands reached monthly across platforms.",
    testimonials: [],
  },
  {
    slug: "hofa-websites",
    key: "social",
    title: "HOFA Websites",
    full: "Digital Home for the ERSEH Framework",
    tagline: "Our programs, stories, and impact — open to all.",
    image: IMG.data,
    body:
      "HOFA's websites (including this one) publish program details, news, match fixtures, and donation channels — making the work transparent and accessible to partners everywhere.",
    highlights: ["Program & news publishing", "Donation & pledge channels", "Transparent impact reporting"],
    impact: "This very site — built and run by HOFA.",
    testimonials: [],
  },
  {
    slug: "jmteei",
    key: "economic",
    title: "JMTEEI",
    full: "James Manneh Tue Economic Empowerment Initiative",
    tagline: "Skills, savings, and small business for lasting income.",
    image: IMG.vocational,
    body:
      "Named in honor of James Manneh Tue, JMTEEI combines vocational training, savings groups, and micro-enterprise support so families can build income that lasts.",
    highlights: ["Vocational & skills training", "Savings & credit circles", "Micro-enterprise support"],
    impact: "Trainees placed in paid work and self-employment each year.",
    testimonials: [],
  },
  {
    slug: "esafc",
    key: "economic",
    title: "ESAFC Football Club",
    full: "Emirates Sports Association FC",
    tagline: "Football as a pathway to opportunity.",
    image: IMG.football,
    body:
      "HOFA acquired ESAFC — a Liberian third-division club — in 2026. Every player is enrolled in school or training; home matches double as community days.",
    highlights: ["12-month player development plan", "FKDP 101 education program", "Home match community days"],
    impact: "First full HOFA-owned season kicks off in 2026.",
    testimonials: [
      { name: "Coach Boakai", role: "ESAFC head coach", quote: "We are not just building footballers. We are building citizens." },
    ],
  },
  {
    slug: "fkdp-101",
    key: "economic",
    title: "FKDP 101",
    full: "Football Knowledge Development Program",
    tagline: "The classroom behind the club.",
    image: IMG.football,
    body:
      "FKDP 101 is ESAFC's education backbone: players study tactics, nutrition, discipline, and life skills alongside their training — because a football career is built in the mind first.",
    highlights: ["Tactics & game-knowledge classes", "Nutrition and discipline modules", "Life-skills curriculum"],
    impact: "Mandatory for every ESAFC player.",
    testimonials: [],
  },
  {
    slug: "cohedip",
    key: "health",
    title: "COHEDIP",
    full: "Community Health Education & Development Intervention Program",
    tagline: "Awareness sessions and outreach across District 17.",
    image: IMG.health,
    body:
      "COHEDIP runs door-to-door health education, community talks, and school-based prevention curricula — from malaria to Ebola preparedness to nutrition.",
    highlights: ["Door-to-door outreach", "School-based curricula", "Seasonal campaigns"],
    impact: "18,000+ people reached in 2025.",
    testimonials: [
      { name: "Nurse Kollie", role: "COHEDIP field team", quote: "Prevention is quieter than a clinic. But this is what keeps families out of the hospital." },
    ],
  },
  {
    slug: "hofaccc",
    key: "social",
    title: "HOFACCC",
    full: "HOFA Comedy and Creative Arts",
    tagline: "Laughter, drama, and creative arts — community joy with a purpose.",
    image: IMG.community,
    body:
      "HOFACCC is HOFA's comedy and creative arts program — staging community comedy, drama, and arts performances that entertain, teach, and carry health and civic messages in a language everyone enjoys. It also gives young performers a stage, training, and an audience.",
    highlights: ["Community comedy & drama performances", "Creative arts workshops for youth", "Messages that teach while they entertain"],
    impact: "Performances staged at community events across District 17.",
    testimonials: [],
  },
];

export function getProgramBySlug(slug) {
  return PROGRAMS.find((p) => p.slug === slug);
}
